// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unsubscribe-plan[data-v-f36fc098]{padding-bottom:20px;padding-top:20px}", ""]);
// Exports
module.exports = exports;
